import { Component, Fragment } from "react";
import SavePopup from "../../../common/SavePopup";
import { dataMapper } from "../../utility/DataMapHelper";
import { headerMapDisplaySections } from "../../EximConstants";
import {
  DKLabel,
  DKIcon,
  DKIcons,
  DKButton,
  DKListPicker,
  showToast,
  TOAST_TYPE,
  showLoader,
  removeLoader,
} from "deskera-ui-library";

class Mapper extends Component {
  constructor(props) {
    super(props);

    this.state = {
      mappedHeaders: this.props.mappedHeaders || [],
      escapeUnMapped: this.props.escapeUnMapped || false,
      isMappingCompleted: false,
      activeToolTip: null,
      activePopupId: null,
      dkHeaderList: [...this.props.systemHeaders],
    };

    this.dkHeaderColumnKey = headerMapDisplaySections[1].key;

    this.defaultHeaderOption = {
      name: "Assign Field",
      id: 0,
      type: "Text",
      options: null,
    };

    this.errorInfoTypes = {
      unmapped:
        "Please either map to existing header/create new field or check the option to skip unmapped fields",
      duplicateMapping:
        "Duplicate Mappings present, please choose different header or create a new field",
      escaped: "Data for this field will be excluded from import",
      required: "Required field. Please add it in import file and try again"
    };
  }

  componentDidMount() {
    if (!this.state.mappedHeaders?.length) {
      try {
        /* FileContent consists of multiple sheets data & 
          each sheet contains multiple rows */
        const importedDataRow = this.props.fileContent[0][0];
        const mappedHeaders = dataMapper(
          importedDataRow,
          this.props.systemHeaders
        );
        this.handleHeaderMappingUpdates(
          mappedHeaders,
          this.dkHeaderColumnKey,
          false
        );
      } catch (err) {
        this.setState({ mappedHeaders: null });
        showToast("No data present in uploaded file", TOAST_TYPE.FAILURE);
      }
    }
  }

  onMappingData = (mappedData, shouldEscapeUnMapped) => {
    if (!mappedData.isMappingValid) {
      mappedData.updatedValues = null;
    }

    this.props.setData({
      mappedHeaders: mappedData.updatedValues,
      escapeUnMapped: shouldEscapeUnMapped,
      importRecords: null,
      invalidRows: null,
    });
  };

  handleValidations = (rowValues, columnKey, shouldEscapeUnmapped) => {
    let isMappingValid = true;
    const headerRowMap = new Map();
    const duplicateRowIds = [];
    let unmappedRows = 0;

    const newRowValues = rowValues.map((rowData, rowIndex) => {
      const newRowData = { ...rowData };

      if (!newRowData[columnKey]) {
        /* Valid Row - if user has opted for escaping unmapped rows */
        newRowData.isValid = shouldEscapeUnmapped;
        isMappingValid = shouldEscapeUnmapped;
        /* Set If the unmappedRow escaped from validations */
        newRowData.isEscaped = shouldEscapeUnmapped;
        newRowData.errorInfo = shouldEscapeUnmapped
          ? this.errorInfoTypes.escaped
          : this.errorInfoTypes.unmapped;
        unmappedRows++;
      } else if (headerRowMap.has(newRowData[columnKey])) {
        const duplicateRowId = headerRowMap.get(newRowData[columnKey]);
        duplicateRowIds.push(duplicateRowId);
        newRowData.isValid = false;
        newRowData.isEscaped = false;
        isMappingValid = false;
        newRowData.errorInfo = this.errorInfoTypes.duplicateMapping;
      } else if (!newRowData["importedKey"]) {
        newRowData.isValid = !newRowData["required"];
        newRowData.isEscaped = false;
        newRowData.errorInfo = newRowData["required"] ? this.errorInfoTypes.required : null;
        if (newRowData["required"]) {
            isMappingValid = false;
        }
      } else {
        newRowData.isValid = true;
        newRowData.isEscaped = false;
        newRowData.errorInfo = null;
        headerRowMap.set(newRowData[columnKey], rowIndex);
      }

      return newRowData;
    });

    duplicateRowIds.forEach((duplicateRowId) => {
      newRowValues[duplicateRowId].isValid = false;
      newRowValues[
        duplicateRowId
      ].errorInfo = this.errorInfoTypes.duplicateMapping;
    });

    /* When All the rows are unmapped */
    if (unmappedRows === rowValues.length) {
      isMappingValid = false;
    }

    return { updatedValues: newRowValues, isMappingValid };
  };

  handleHeaderMappingUpdates = (
    mappedHeaders,
    columnKey,
    shouldEscapeUnMapped
  ) => {
    const validatedData = this.handleValidations(
      mappedHeaders,
      columnKey,
      shouldEscapeUnMapped
    );

    this.setState({
      escapeUnMapped: shouldEscapeUnMapped,
      mappedHeaders: validatedData.updatedValues,
      isMappingCompleted: validatedData.isMappingValid,
    });

    this.onMappingData(validatedData, shouldEscapeUnMapped);
  };

  handleUpdateSelection = (selectedValue, columnKey, rowId) => {
    /* By default setting to assign field */
    let selectedHeader = this.defaultHeaderOption;

    if (selectedValue) {
      selectedHeader = this.state.dkHeaderList[selectedValue - 1];
    }

    const updatedHeaderMappings = this.state.mappedHeaders.map((headerRow) => {
      if (headerRow.rowId === rowId) {
        headerRow[columnKey] = selectedHeader.id;
        headerRow.selectedOption = selectedHeader.name;
        headerRow.type = selectedHeader.type;
        headerRow.options = selectedHeader.options;
        headerRow.showPicker = false;
      }

      return headerRow;
    });

    this.handleHeaderMappingUpdates(updatedHeaderMappings, columnKey, false);
  };

  onClickEscapeMappingCheckbox = () => {
    const { mappedHeaders, escapeUnMapped } = this.state;
    this.handleHeaderMappingUpdates(
      mappedHeaders,
      this.dkHeaderColumnKey,
      !escapeUnMapped
    );
  };

  handlePickerDisplay = (rowId, hide) => {
    const newMappedHeaders = this.state.mappedHeaders.map((header) => {
      if (header.rowId === rowId) {
        header.showPicker = !hide;
      } else {
        header.showPicker = false;
      }

      return header;
    });

    this.setState({ mappedHeaders: newMappedHeaders });
  };

  onSaveNewField = (fieldName, domain) => {
    const rowId = this.state.activePopupId;

    const newFieldIndex = this.state.dkHeaderList.length;
    const newColumnData = {
      name: fieldName,
      type: "Text",
    };

    showLoader("Saving... Please wait");
    this.props
      .generateNewColumn(newColumnData, this.props.tableName)
      .then((response) => {
        const { id, columnData } = response;
        if (id) {
          showToast("Field added successfully", TOAST_TYPE.SUCCESS);
          this.props.setTableColumns(this.props.tableName);

          columnData.id = id;
          columnData.key = id;
          columnData.index = newFieldIndex;

          this.setState(
            (prevState) => ({
              dkHeaderList: [...prevState.dkHeaderList, response.columnData],
              activePopupId: null,
            }),
            () => {
              this.handleUpdateSelection(
                newFieldIndex + 1,
                this.dkHeaderColumnKey,
                rowId
              );
            }
          );
        }
      })
      .catch((err) => {
        showToast(`${fieldName} column cannot be created.`, TOAST_TYPE.FAILURE);
      })
      .finally(() => {
        removeLoader();
      });
  };

  getNewFieldPopup = () => {
    return this.state.activePopupId ? (
      <SavePopup
        header="Create New Field"
        headerIcon=""
        subHeader="Please enter the field name for a new text field"
        onSave={this.onSaveNewField}
        onCancel={() => {
          this.setState({ activePopupId: null });
        }}
      />
    ) : null;
  };

  getGridHeader() {
    return (
      <Fragment>
        <DKLabel
          text="Column Mapper"
          className="fw-m fs-l m-v-s p-h-r text-align-center parent-width"
        />
        <DKLabel
          text="Map your columns with headers present in the system"
          className="text-gray text-align-center parent-width mb-m p-h-r"
        />
        <div className="row bg-gray1 justify-content-between align-items-center p-v-r p-h-xl mt-l">
          {headerMapDisplaySections.map((column) => (
            <DKLabel
              key={column.key}
              text={column.name}
              className="fw-m fs-m"
              style={{ width: 250 }}
            />
          ))}
        </div>
      </Fragment>
    );
  }

  getWarningToolTip(toolTipId, errorInfo) {
    return (
      <div
        className="position-absolute z-index-1 m-h-r"
        style={{ right: 20 }}
        onMouseOver={() => {
          this.setState({ activeToolTip: toolTipId });
        }}
        onMouseOut={() => {
          this.setState({ activeToolTip: null });
        }}
      >
        <DKIcon src={DKIcons.ic_info} className="ic-s-2 cursor-hand" />
        {this.state.activeToolTip === toolTipId && (
          <div
            className="bg-white border-red position-absolute border-radius-s pr-s pt-xs pb-xs"
            style={{
              left: 30,
              top: -5,
              width: 200,
            }}
          >
            {errorInfo}
          </div>
        )}
      </div>
    );
  }

  getRow(rowData, headerListOptions) {
    const rowClassNames = [];
    if (rowData.isEscaped) {
      rowClassNames.push("text-gray");
      rowClassNames.push("bg-chip-gray");
    } else if (!rowData.isValid) {
      rowClassNames.push("border-red");
      rowClassNames.push("data-grid-badge-color-4");
    }

    return (
      <div
        key={rowData.rowId}
        id={rowData.rowId}
        style={{ minHeight: "50px" }}
        className={`position-relative row border-m-b align-items-center justify-content-between p-v-r p-h-xl ${rowClassNames.join(
          " "
        )}`}
      >
        <div style={{ width: 250 }}>
            <DKLabel
                text={rowData.importedKey}
                className=""
                style={{ width: 200 }}
            />
        </div>
        {rowData.showPicker ? (
          <DKListPicker
            title="System Fields"
            className="position-absolute border-m shadow-m z-index-3"
            style={{ top: 10, left: 250, width: 250, marginRight: "auto" }}
            data={headerListOptions}
            onSelect={(selectedDisplayHeader) => {
              this.handleUpdateSelection(
                selectedDisplayHeader,
                this.dkHeaderColumnKey,
                rowData.rowId
              );
            }}
            onClose={() => {
              this.handlePickerDisplay(rowData.rowId, true);
            }}
            button={{
              title: "Create New Field",
              className: "bg-app text-white",
              onClick: () => {
                this.setState({ activePopupId: rowData.rowId });
              },
            }}
          />
        ) : (
          <div style={{ width: 250 }}>
              <div
                className="row cursor-hand"
                onClick={() => this.handlePickerDisplay(rowData.rowId)}
                style={{ width: 180 }}
            >
                <DKLabel
                    text={rowData.selectedOption}
                    style={{ width: 160 }}
                />
                <DKIcon
                    className="ic-s ml-s"
                    src={DKIcons.ic_arrow_down2}
                />
              </div>
          </div>
        )}
        <DKLabel
          text={rowData.sampleData}
          className="fs-m"
          style={{ width: 250 }}
        />
        {rowData.errorInfo &&
          this.getWarningToolTip(`tooltip-${rowData.rowId}`, rowData.errorInfo)}
      </div>
    );
  }

  getGridRows() {
    const { dkHeaderList } = this.state;
    const headerListOptions = [this.defaultHeaderOption.name];

    dkHeaderList.forEach((header) => {
      headerListOptions.push(header.name);
    });

    return this.state.mappedHeaders ? (
      <Fragment>
        {this.state.mappedHeaders.map((headerRow) =>
          this.getRow(headerRow, headerListOptions)
        )}
        <label
          htmlFor="validationEscaper"
          className="row cursor-hand p-h-l pt-m width-auto"
        >
          <input
            id="validationEscaper"
            type="checkbox"
            className="cursor-hand"
            checked={this.state.escapeUnMapped}
            onChange={this.onClickEscapeMappingCheckbox}
          />
          <DKLabel text="Skip columns that do not map (Note: Required fields cannot be skipped)" />
        </label>
      </Fragment>
    ) : (
      <DKLabel text="No mappings found" className="p-xl bg-white text-red" />
    );
  }

  render() {
    return (
      <div className="column bg-white position-relative p-v-r shadow-s border-radius-s">
        {this.getGridHeader()}
        {this.getGridRows()}
        {this.getNewFieldPopup()}
      </div>
    );
  }
}

export default Mapper;
